import { createAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';

export interface ToggleSearch {
    open?: boolean;
}

export const toggleSearch = createAction<ActionType, ToggleSearch>(
    ActionType.NOTI__EC__TOGGLE_SEARCH,
);
